import {
  pushAnalyticsObjToDataLayer,
  sanitizeTextForAnalytics,
} from "@/utils/helper"

export const technicalSpecsServicePartsAnalytics = (
  pageType,
  zone,
  productInfo,
  internalName
) => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${pageType}:main content area:${zone}:interactive parts diagram`,
    eventMsg: "n/a",
    eventName: `${pageType}:main content area:${zone}:interactive parts diagram`,
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: sanitizeTextForAnalytics(internalName?.toLowerCase()),
    internalLinkPosition: pageType,
    internalLinkType: `${pageType}:navigation`,
    internalLinkURL: "n/a",
    internalLinkZoneName: `${pageType}:${zone}`,
  }

  pushAnalyticsObjToDataLayer(
    eventInfo,
    "cmp:click",
    {},
    typeof productInfo === "string" ? JSON.parse(productInfo) : productInfo
  )
}

export const datalayerForShareClick = (eventInfoData, productInfo) => {
  const eventInfo =
    typeof eventInfoData === "string"
      ? JSON.parse(eventInfoData)
      : eventInfoData
  pushAnalyticsObjToDataLayer(
    eventInfo,
    "cmp:click",
    {},
    typeof productInfo === "string" ? JSON.parse(productInfo) : productInfo
  )
}

const getTechnicalFileName = file => {
  return sanitizeTextForAnalytics(
    `${file.title?.trim()?.toLowerCase()}.${file.type}`
  )
}

const getTechnicalInfoDownloadEventInfo = (status, message, file, pageName) => {
  if (pageName === "technicalspecs") {
    return {
      eventAction: "technical specs:main content area:technical info:download",
      eventName: "technical specs:main content area:technical info:download",
      eventType: "navigation",
      eventMsg: message || "n/a",
      eventStatus: status || "n/a",
      internalLinkName: getTechnicalFileName(file),
      internalLinkPosition: "tech specs",
      internalLinkType: "technical specs:technical info",
      internalLinkZoneName: "technical specs:main content area",
      internalLinkURL: `${file.url}`,
      clickInternalLinks: "true",
      fileNameAndFileType: getTechnicalFileName(file),
    }
  } else {
    return {
      eventAction: "search results:technical:main content area:download",
      eventName: "search results:technical:main content area:download",
      eventType: "navigation",
      eventMsg: message || "n/a",
      eventStatus: status || "n/a",
      internalLinkName: getTechnicalFileName(file),
      internalLinkPosition: "search results",
      internalLinkType: "search results:technical info",
      internalLinkZoneName: "search results:technical:main content area",
      internalLinkURL: `${file.url}`,
      clickInternalLinks: "true",
      fileNameAndFileType: getTechnicalFileName(file),
    }
  }
}

export const addSpecsDownloadFilesAnalytics = (
  status,
  message,
  file,
  productInfo,
  pageName
) => {
  const eventInfo = getTechnicalInfoDownloadEventInfo(
    status,
    message,
    file,
    pageName
  )
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const pI = JSON.parse(productInfo).productInfo
  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    page,
    productInfo: pI,
  })
}
